/** @jsx jsx */
import { css, keyframes } from '@emotion/react';

const ANIMATION_DURATION = 0.3;
const ANIMATION_DELAY = 0.15;
const GLOBAL_HEADER_HEIGHT = 70;

export const defaultStyleSizes = {
  globalHeaderHeight: GLOBAL_HEADER_HEIGHT,
  width: 410,
  height: `calc(100% - ${GLOBAL_HEADER_HEIGHT}px)`,
  headerHeight: 50,
  senderHeight: 50,
};

const enterFullScreenAnimation = keyframes`
  100% {
    height: 100%;
    width: 100%;
    max-width: 100vw;
    right: -20px;
    bottom: -20px;
  }
`;

const exitFullScreenAnimation = keyframes`
  0% {
    height: 100%;
    width: 100%;
    max-width: 100vw;
  }
  100% {
    height: ${defaultStyleSizes.height};
    width: ${defaultStyleSizes.width}px;
    right: 0;
    bottom: 0;
    max-width: ${defaultStyleSizes.width}px;
  }
`;

export const fullScreenStyles = {
  enterFullScreenAnimation,
  exitFullScreenAnimation,
  exitFullScreen: css`
    animation-name: ${exitFullScreenAnimation} !important;
    animation-delay: ${ANIMATION_DELAY}s;
    animation-duration: ${ANIMATION_DURATION}s;
    animation-fill-mode: backwards;
  `,

  fullScreen: css`
    max-width: 100vw;
    background-color: white;
    animation-fill-mode: forwards;
    animation-property: bottom, right, min-width, min-height, max-width, max-height !important; /* stylelint-disable-line property-no-unknown */
    animation-name: ${enterFullScreenAnimation} !important;
    animation-delay: ${ANIMATION_DELAY}s;
    animation-duration: ${ANIMATION_DURATION}s;
  `,
};
